import { Transforms } from 'slate';
import { type ReactEditor } from 'slate-react';

import deserializeHtml from './deserializeHtml';

const withHtml = (editor: ReactEditor): ReactEditor => {
  const { insertData } = editor;

  editor.insertData = (data) => {
    const html = data.getData('text/html');

    if (html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fragment = deserializeHtml(parsed.body);

      if (fragment.length > 0) {
        Transforms.insertFragment(editor, fragment);
        return;
      }
    }

    insertData(data);
  };

  return editor;
};

export default withHtml;
